import type { FC } from 'react'
import { Typography } from '@mui/material'
import { ProfileViewAlertContainer } from './ProfileViewAlertContainer'
import { theme } from '~/lib/theme'

export const ProfileViewCountSuccess: FC<{ rate: number }> = ({ rate }) => {
  return (
    <ProfileViewAlertContainer variant="success">
      <Typography variant="body2">
        プロフィール閲覧数が選択期間で
        <span
          style={{
            color: theme.palette.success.main,
            fontWeight: 'bold',
            fontSize: '1.2em',
          }}
        >
          {rate}%
        </span>
        増加しました。
      </Typography>
    </ProfileViewAlertContainer>
  )
}
